<template>
    <div
        class="game-board-wrapper"
		:class="{
			['two-player-full-board']: this.isMobile  &&
				isTwoPlayerFullBoard &&
				screenOrientation === 0,
		}"
        :style="{
            maxWidth: `${this.boardMaxWidth}px`,
        }"
        ref="game-board-wrapper-ref"
    >
        <div class="game-board" :class="{'mini-board': renderMiniBoard }" v-if="renderMiniBoard" >
            <div
                class="hex"
                :class="{['visible']: getPosition(index)}"
                v-for="(hex, index) in miniBoardHexes"
                :key="`hex-${index}`"
            >
                <tile
                    :position="getPosition(index)"
                    :units="findUnitsByPosition(getPosition(index))"
                    :gameState="gameState"
                    :index="index"
                >
                </tile>
            </div>
        </div>
        <div class="game-board" :class="{'mini-board': renderMiniBoard }" v-if="!renderMiniBoard">
            <div
                class="hex"
                :class="{['visible']: getPosition(index)}"
                v-for="(hex, index) in hexes"
                :key="`hex-${index}`"
            >
                <tile
                    :position="getPosition(index)"
                    :units="findUnitsByPosition(getPosition(index))"
                    :gameState="gameState"
                    :index="index"
                >
                </tile>
            </div>
        </div>
    </div>

</template>

<script>
import {
	UNIT_STATE_DEPLOYED,
	UNIT_TYPE_LONGBOAT,
	UNIT_TYPE_PIRATE,
} from '../Unit/Unit-types';
import { COLOR_BLACK } from '../Player/Player-types';
import { MOBILE_MAX_WIDTH } from '../../App-types';
import { isMobileDevice } from '../../helpers/general';

export default {
    name: 'Board',
    props: ['gameState'],
    mounted() {
        this.setBoardMaxHeight();

		const boardWrapper = this.$refs['game-board-wrapper-ref'];

		const checkAndScroll = setInterval(() => {

			if (boardWrapper) {
				const scrollWidth = boardWrapper.scrollWidth;
				const clientWidth = boardWrapper.clientWidth;

				if (boardWrapper.scrollLeft === 0) {
					boardWrapper.scrollLeft = (scrollWidth - clientWidth) / 2;
				}

				if (boardWrapper.scrollLeft !== 0) {
					clearInterval(checkAndScroll);
				}
			}
		}, 100);

		setTimeout(() => {
			clearInterval(checkAndScroll);
		}, 2000);
	},
    created() {
        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('orientationchange', this.onWindowResize);

        if (screen && screen.orientation) {
            screen.orientation.addEventListener('change', this.onWindowResize);
        }
    },
    unmounted() {
        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('orientationchange', this.onWindowResize);

        if (screen && screen.orientation) {
            screen.orientation.removeEventListener('change', this.onWindowResize);
        }
    },
    data() {
        return {
            boardMaxWidth: 0,
            windowWidth: window.innerWidth,
            miniBoardHexes: new Array(55),
            miniBoardHexPositions: {
                ['2']: '0,5',
                ['3']: '0,6',
                ['4']: '1,6',
                ['7']: '0,3',
                ['8']: '0,4',
                ['9']: '1,4',
                ['10']: '1,5',
                ['11']: '2,5',
                ['12']: '2,6',
                ['13']: '3,6',
                ['14']: '1,2',
                ['15']: '1,3',
                ['16']: '2,3',
                ['17']: '2,4',
                ['18']: '3,4',
                ['19']: '3,5',
                ['20']: '4,5',
                ['21']: '2,1',
                ['22']: '2,2',
                ['23']: '3,2',
                ['24']: '3,3',
                ['25']: '4,3',
                ['26']: '4,4',
                ['27']: '5,4',
                ['28']: '3,0',
                ['29']: '3,1',
                ['30']: '4,1',
                ['31']: '4,2',
                ['32']: '5,2',
                ['33']: '5,3',
                ['34']: '6,3',
                ['36']: '4,0',
                ['37']: '5,0',
                ['38']: '5,1',
                ['39']: '6,1',
                ['40']: '6,2',
                ['45']: '6,0',
            },
            miniBoardHexPositionsFlipped: {
                ['2']: '6,1',
                ['3']: '6,0',
                ['4']: '5,0',
                ['7']: '6,3',
                ['8']: '6,2',
                ['9']: '5,2',
                ['10']: '5,1',
                ['11']: '4,1',
                ['12']: '4,0',
                ['13']: '3,0',
                ['14']: '5,4',
                ['15']: '5,3',
                ['16']: '4,3',
                ['17']: '4,2',
                ['18']: '3,2',
                ['19']: '3,1',
                ['20']: '2,1',
                ['21']: '4,5',
                ['22']: '4,4',
                ['23']: '3,4',
                ['24']: '3,3',
                ['25']: '2,3',
                ['26']: '2,2',
                ['27']: '1,2',
                ['28']: '3,6',
                ['29']: '3,5',
                ['30']: '2,5',
                ['31']: '2,4',
                ['32']: '1,4',
                ['33']: '1,3',
                ['34']: '0,3',
                ['36']: '2,6',
                ['37']: '1,6',
                ['38']: '1,5',
                ['39']: '0,5',
                ['40']: '0,4',
                ['45']: '0,6',
            },
            hexes: new Array(77),
            hexPositions: {
                ['4']: '0,5',
                ['5']: '0,6',
                ['6']: '1,6',
                ['13']: '0,3',
                ['14']: '0,4',
                ['15']: '1,4',
                ['16']: '1,5',
                ['17']: '2,5',
                ['18']: '2,6',
                ['19']: '3,6',
                ['22']: '0,1',
                ['23']: '0,2',
                ['24']: '1,2',
                ['25']: '1,3',
                ['26']: '2,3',
                ['27']: '2,4',
                ['28']: '3,4',
                ['29']: '3,5',
                ['30']: '4,5',
                ['31']: '4,6',
                ['32']: '5,6',
                ['33']: '1,0',
                ['34']: '1,1',
                ['35']: '2,1',
                ['36']: '2,2',
                ['37']: '3,2',
                ['38']: '3,3',
                ['39']: '4,3',
                ['40']: '4,4',
                ['41']: '5,4',
                ['42']: '5,5',
                ['43']: '6,5',
                ['45']: '2,0',
                ['46']: '3,0',
                ['47']: '3,1',
                ['48']: '4,1',
                ['49']: '4,2',
                ['50']: '5,2',
                ['51']: '5,3',
                ['52']: '6,3',
                ['53']: '6,4',
                ['58']: '4,0',
                ['59']: '5,0',
                ['60']: '5,1',
                ['61']: '6,1',
                ['62']: '6,2',
                ['71']: '6,0',
            },
            hexPositionsFlipped: {
                ['4']: '6,1',
                ['5']: '6,0',
                ['6']: '5,0',
                ['13']: '6,3',
                ['14']: '6,2',
                ['15']: '5,2',
                ['16']: '5,1',
                ['17']: '4,1',
                ['18']: '4,0',
                ['19']: '3,0',
                ['22']: '6,5',
                ['23']: '6,4',
                ['24']: '5,4',
                ['25']: '5,3',
                ['26']: '4,3',
                ['27']: '4,2',
                ['28']: '3,2',
                ['29']: '3,1',
                ['30']: '2,1',
                ['31']: '2,0',
                ['32']: '1,0',
                ['33']: '5,6',
                ['34']: '5,5',
                ['35']: '4,5',
                ['36']: '4,4',
                ['37']: '3,4',
                ['38']: '3,3',
                ['39']: '2,3',
                ['40']: '2,2',
                ['41']: '1,2',
                ['42']: '1,1',
                ['43']: '0,1',
                ['45']: '4,6',
                ['46']: '3,6',
                ['47']: '3,5',
                ['48']: '2,5',
                ['49']: '2,4',
                ['50']: '1,4',
                ['51']: '1,3',
                ['52']: '0,3',
                ['53']: '0,2',
                ['58']: '2,6',
                ['59']: '1,6',
                ['60']: '1,5',
                ['61']: '0,5',
                ['62']: '0,4',
                ['71']: '0,6',
            },
        };
    },
    computed: {
		actionsState() {
            return this.$store.state.actionsState;
        },
		screenOrientation() {
			return window.orientation?.angel || screen?.orientation?.angle;
		},
        resolvedHexes() {
            return this.renderMiniBoard ? this.miniBoardHexes : this.hexPositions;
        },
        renderMiniBoard() {
            return this.isMobile &&
				this.gameState.numOfPlayers === 2 &&
				!this.isTwoPlayerFullBoard;
        },
		isTwoPlayerFullBoard() {
			return this.gameState.twoPlayersFullBoard ||
				this.gameState.unitTypes.find(u => u.type === UNIT_TYPE_PIRATE);
		},
        isMobile() {
            return this.windowWidth <= MOBILE_MAX_WIDTH || isMobileDevice();
        },
        isGame() {
            return this.$route.name === 'game';
        },
        userId() {
            return this.$store.state.loginState.userId;
        },
        players() {
            return this.gameState.players;
        },
        player() {
            return this.isGame ? this.$store.getters.player : this.$store.getters.replayPlayer;
        },
        flipBoard() {
            return this.player.team.color === COLOR_BLACK;
        },
        deployedUnits() {
            const units = [];

            for (const player of this.gameState.players) {
                for (const unit of player.units) {
                    if (unit.state === UNIT_STATE_DEPLOYED) {
                        units.push(unit);
                    }
                }
            }

            return units;
        },
        resolvedHexPositions() {
            if (this.renderMiniBoard) {
                return this.flipBoard ? this.miniBoardHexPositionsFlipped : this.miniBoardHexPositions;
            }

            return this.flipBoard ? this.hexPositionsFlipped : this.hexPositions;
        },
    },
    methods: {
		 findUnitsByPosition(position) {
			const unitsAtPosition = this.deployedUnits.filter(unit => unit.position === position);

			if (unitsAtPosition.length === 0) {
				return [];
			}

			const longboat = unitsAtPosition.find(unit => unit.type === UNIT_TYPE_LONGBOAT);

			if (longboat) {
				const otherUnit = unitsAtPosition.find(unit => unit.id !== longboat.id);
				let otherBolsteredUnits = [];

				if (otherUnit) {
					otherBolsteredUnits = this.deployedUnits.filter(u => u.parentUnitId === otherUnit.id);
				}

				if (this.actionsState.flipLongboat) {
					return [otherUnit, ...otherBolsteredUnits, longboat].filter(Boolean);
				}

				return [longboat, otherUnit, ...otherBolsteredUnits].filter(Boolean);
			}

			const unitInPosition = unitsAtPosition[0];
			const units = [unitInPosition];

			for (const unit of this.deployedUnits) {
				if (unit.parentUnitId === unitInPosition.id) {
					if (unit.type === unitInPosition.type) {
						units.push(unit);
					} else {
						units.unshift({ ...unit, type: null });
					}
				}
			}

			return units;
		},
        getPosition(index) {
            return this.resolvedHexPositions[String(index)];
        },
        onWindowResize(event) {
            if (['orientationchange', 'change'].includes(event.type)) {
                if (window.orientation === 90 || screen?.orientation?.angle === 90) {
                    const boardHeight = this.$parent.$refs['board-wrapper']?.clientHeight;
                    this.boardMaxWidth = boardHeight > 0 ? boardHeight * .75 : 300;
                } else {
                    return;
                }
            }

            setTimeout(() => {
                this.windowWidth = window.innerWidth;
                this.setBoardMaxHeight();
            }, 0);
        },
        setBoardMaxHeight() {
            const boardHeight = this.$parent.$refs['board-wrapper']?.clientHeight ?? 450;
            this.boardMaxWidth = boardHeight * 1.35;
        },
    },
};
</script>

<style scoped lang="scss">
@use "@/styles/styles.scss" as *;

$columns: 11;
$rows: 7;

.game-board-wrapper {

	&.two-player-full-board {
		overflow: scroll;
		width: 90%;

		.game-board {
			width: 150%;
		}
	}
}

.game-board {
    --columns: 11;
    --counter: 1;

    display: grid;
    grid-gap: .1rem .2rem;
    grid-template-columns: repeat(var(--columns),1fr 2fr) 1fr;
    list-style-type: none;
    position: relative;

    .hex {
        grid-column: 1 / span 3;
        grid-row: calc(var(--counter) + var(--counter)) / span 2;
        height: 0;
        padding-bottom: 90%;
        position: relative;
        display: none;

        &.visible {
            display: inline-block;
        }

        // Columns
        @for $i from 1 through $columns {
            &:nth-of-type(#{$columns}n + #{$i}) {
                grid-column: #{$i + $i - 1} / span 3;

                @if $i % 2 == 0 {
                    grid-row: calc(var(--counter) + var(--counter) - 1) / span 2;
                }
            }
        }

        // Rows
        @for $i from 1 through $rows {
            &:nth-of-type(n + #{$i * $columns + 1}) {
                --counter: #{$i + 1};
            }
        }
    }
}

$columns: 7;

.game-board {

    &.mini-board {
        --columns: 7;
        --counter: 1;

        display: grid;
        grid-gap: .1rem .2rem;
        grid-template-columns: repeat(var(--columns),1fr 2fr) 1fr;
        list-style-type: none;
        position: relative;

        .hex {
            grid-column: 1 / span 3;
            grid-row: calc(var(--counter) + var(--counter)) / span 2;
            height: 0;
            padding-bottom: 90%;
            position: relative;
            display: none;

            &.visible {
                display: inline-block;
            }

            // Columns
            @for $i from 1 through $columns {
                &:nth-of-type(#{$columns}n + #{$i}) {
                    grid-column: #{$i + $i - 1} / span 3;

                    @if $i % 2 == 0 {
                        grid-row: calc(var(--counter) + var(--counter) - 1) / span 2;
                    }
                }
            }

            // Rows
            @for $i from 1 through $rows {
                &:nth-of-type(n + #{$i * $columns + 1}) {
                    --counter: #{$i + 1};
                }
            }
        }
    }
}

@media only screen and (min-width: $screen-sm) {

    .game-board {
        grid-gap: .15rem .3rem;
    }
}
</style>
